"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildLang = exports.setI18nLang = exports.getI18nLang = exports.createKeyset = void 0;
exports.createI18n = createI18n;
exports.createI18nRaw = createI18nRaw;
const react_1 = require("react");
const i18n_1 = require("@yandex-int/i18n");
var createKeyset_1 = require("./lib/keysets/createKeyset");
Object.defineProperty(exports, "createKeyset", { enumerable: true, get: function () { return createKeyset_1.createKeyset; } });
var i18n_2 = require("@yandex-int/i18n");
Object.defineProperty(exports, "getI18nLang", { enumerable: true, get: function () { return i18n_2.getI18nLang; } });
Object.defineProperty(exports, "setI18nLang", { enumerable: true, get: function () { return i18n_2.setI18nLang; } });
var langs_1 = require("./lib/langs");
Object.defineProperty(exports, "BuildLang", { enumerable: true, get: function () { return langs_1.BuildLang; } });
function createI18n(keyset) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return (0, i18n_1.default)(keyset);
}
function createI18nRaw(keyset) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    const i18nRawInt = (0, i18n_1.i18nRaw)(keyset);
    const i18nRaw = function i18nRaw(key, options) {
        return i18nRawInt(key, options).map((node, index) => {
            if (typeof node !== 'object') {
                return node;
            }
            return (0, react_1.createElement)(react_1.Fragment, { key: index }, node);
        });
    };
    return i18nRaw;
}
